import React from 'react';
import './Input.scss';

function Input({
  placeholder,
  value,
  onInputChangeHandler,
  onFocusChangeHandler,
  onBlurChangeHandler,
  dataTestId,
  maxLength,
  name,
  autoComplete,
  inputHasError,
  onChange
}) {
  return (
    <input
      className={`form-control prequal--web--prequal-form-text-input-fomo ${inputHasError ? 'prequal--web--text-input-has-error' : ''}`}
      maxLength={maxLength}
      onInput={onInputChangeHandler}
      onFocus={onFocusChangeHandler}
      onBlur={onBlurChangeHandler}
      required
      slot='input'
      name={name}
      data-testid={dataTestId}
      value={value}
      placeholder={placeholder}
      autoComplete={autoComplete}
      onChange={onChange}
      id={name}
    />
  );
}

export default Input;
